/* src/app/pages/auth/signup/verification/verification.component.scss */
.center_div {
  margin-top: 10px;
  margin-left: 50px;
  width: 70%;
}
/*# sourceMappingURL=verification.component.css.map */
